import vModal from "@/components/modal.vue";
import { db } from "@/service/firebase";
import SvgIcon from "@jamescoyle/vue-icon";
import axios from "axios";
import { addDoc, collection, Timestamp } from "firebase/firestore";
import VueMask from "v-mask";
import Vue from "vue";
import VIcon from "vue-tailwind-icons";
import App from "./App.vue";
import "./index.css";
import "./registerServiceWorker";
import router from "./router";
import { loggerError } from "./service/firebase";
import store from "./store";

Vue.use(VueMask);
Vue.config.productionTip = false;
Vue.component("v-modal", vModal);
Vue.component("svg-icon", SvgIcon);
Vue.use(VIcon);
Vue.use(VIcon, { set: "outline" });
//https://www.zondicons.com/icons.html

function actErr(err, info) {
  console.error(err, info);
  appvue.$root.sendOneError(err, info);
}

Vue.config.warnHandler = (err, vm, info) => {
  actErr(err, info);
};

Vue.config.errorHandler = (err, vm, info) => {
  const vmData = vm ? vm.$data : null;
  loggerError(err, vmData);
  actErr(err, info);
};

axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

var appvue = new Vue({
  methods: {
    goto(path, replaceRoute) {
      if (this.$route.path == path) {
        return;
      } else {
        if (replaceRoute) this.$router.replace(path);
        else this.$router.push(path);
      }
    },
    async sendOneError(err, tracker) {
      if (process.env.VUE_APP_ENV == "development") return false;
      
      let compra = this.$store.state.compra;
      let rota = this.$route.path || null;
      const referencia = collection(db, "erros");

      // Serializa o erro
      const errorSerializado = err instanceof Error
        ? { mensagem: err.message, stack: err.stack, nome: err.name }
        : { mensagem: String(err) };

      let payload = {
        time: Timestamp.fromDate(new Date()),
        totem_id: compra.totem_id || null,
        error: errorSerializado,
        info: tracker || null,
        route: rota,
        compra: compra.id || null,
      };

      await addDoc(referencia, payload);
    },
  },
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
